import { useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';
import { useParams } from 'react-router';
import styled from 'styled-components';
import { EditCategoryWithLoader } from './loaders';
import FaqCategory from './faq';
import {
    getCatalogCategories,
    getCatalogCategory,
} from '../../../../actions/category';
import { units } from '../../../../helpers/styles/units';
import { Tabs } from '../../../../components/SiteBody/SiteBodyTabs';

const tabDdata = [
    { name: 'Основные настройки', content: <EditCategoryWithLoader /> },
    { name: 'FAQ категории', content: <FaqCategory /> },
];

const StyledWrapper = styled.div`
  display: flex;
  flex-direction: column;
  padding-left: ${units(12)};
`;

export const EditSettings = () => {
    const dispatch = useDispatch();
    const [active, setActive] = useState(0);
    const { categoryId } = useParams<{ categoryId: string }>();

    useEffect(() => {
        dispatch(getCatalogCategory(categoryId));
        dispatch(getCatalogCategories());
    }, [categoryId]);

    return (
        <StyledWrapper>
            <Tabs data={tabDdata} active={active} setActive={setActive} />
        </StyledWrapper>
    );
};
